var UpdateActivityResultRequestBodyScorePlayedEnum;
(function (UpdateActivityResultRequestBodyScorePlayedEnum) {
    UpdateActivityResultRequestBodyScorePlayedEnum["RegularTime"] = "played_regular_time";
    UpdateActivityResultRequestBodyScorePlayedEnum["Overtime"] = "played_overtime";
})(UpdateActivityResultRequestBodyScorePlayedEnum || (UpdateActivityResultRequestBodyScorePlayedEnum = {}));
var UpdateActivityResultRequestBodyOpEnum;
(function (UpdateActivityResultRequestBodyOpEnum) {
    UpdateActivityResultRequestBodyOpEnum["Reset"] = "reset";
    UpdateActivityResultRequestBodyOpEnum["Score"] = "score";
    UpdateActivityResultRequestBodyOpEnum["ForfeitHome"] = "forfeit_home";
    UpdateActivityResultRequestBodyOpEnum["ForfeitAway"] = "forfeit_away";
    UpdateActivityResultRequestBodyOpEnum["ForfeitBoth"] = "forfeit_both";
})(UpdateActivityResultRequestBodyOpEnum || (UpdateActivityResultRequestBodyOpEnum = {}));
var UpdateActivityResultRequestBodyStandingExcludeEnum;
(function (UpdateActivityResultRequestBodyStandingExcludeEnum) {
    UpdateActivityResultRequestBodyStandingExcludeEnum["Home"] = "home";
    UpdateActivityResultRequestBodyStandingExcludeEnum["Away"] = "away";
    UpdateActivityResultRequestBodyStandingExcludeEnum["Both"] = "both";
})(UpdateActivityResultRequestBodyStandingExcludeEnum || (UpdateActivityResultRequestBodyStandingExcludeEnum = {}));
export {};
